import { z } from 'zod'
import {
  userDataSchema,
  zodAddressCountString,
  eventDataSchema,
  zodBoolean,
} from '../../common.schema'

export const SelectRecipientSchema = z.object({
  event: z.literal('select_recipient'),

  user_data: userDataSchema
    .extend({
      address_count: zodAddressCountString,
      is_logged_in: zodBoolean.optional(),
    })
    .optional(),

  event_data: eventDataSchema,
})

export type SelectRecipientEvent = z.infer<typeof SelectRecipientSchema>
